import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';


export class RomData extends Component {

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }
        return ({ TypeId: "", TypeName: "" });
    };

    render() {
        const {
            //onChange,
            onSelectChange,
            //onChangetypeOfROM,
            typeOfROM,
            //projectTitle,
            //projectNumber,
            //status
            userType,
        } = this.props;

        var typeOfROMOptions = [
            { TypeId: 1, TypeName: "On Going" },
            { TypeId: 2, TypeName: "Ex-Post" },
            { TypeId: 3, TypeName: "Supply On Going" },
            { TypeId: 4, TypeName: "Supply Ex-Post" },
            { TypeId: 5, TypeName: "Works On Going" },
            { TypeId: 6, TypeName: "Works Ex-Post" },
        ];

        return (
            <Card>
                <CardHeader title="ROM Data" className='romis-card-header' />
                <CardContent>
                    <Autocomplete
                        options={typeOfROMOptions}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChange(e, v, "typeOfROM")}
                        value={this.returnArrayElement(typeOfROMOptions, typeOfROM)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Type of ROM"
                                placeholder="Type of ROM"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />
                </CardContent>
            </Card>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/RomData.js